import type { TipoDocumento } from '@/types/documento'

export interface TipoDocumentoConfig {
  label: string
  /**
   * Los cinco tipos comparten estado y forma; lo único que los distingue de un
   * vistazo es el glifo. Por eso el ícono es parte de la configuración del
   * tipo y no una decisión de cada pantalla.
   */
  icon: string
}

/**
 * Nombre e ícono de cada tipo de documento firmado en terreno — fuente ÚNICA.
 *
 * Vivía dentro de `BandejaEntrada.tsx`. Se extrajo cuando el listado de
 * Trabajadores necesitó rotular la última firma de cada trabajador: dos copias
 * del mismo mapa es exactamente cómo un rename se aplica en una pantalla y no
 * en la otra. Ya pasó una vez — "Check Camioneta" → "Check Vehículos" es un
 * rename VISUAL sobre un enum que en la base sigue diciendo `CHECK_CAMIONETA`,
 * así que el label no se puede derivar del valor crudo.
 */
export const TIPO_DOCUMENTO_CONFIG: Record<TipoDocumento, TipoDocumentoConfig> = {
  EPP: { label: 'Entrega EPP', icon: 'health_and_safety' },
  CAPACITACION: { label: 'Capacitaciones', icon: 'school' },
  ATS: { label: 'Análisis de Trabajo Seguro (ATS)', icon: 'fact_check' },
  CHECK_CAMIONETA: { label: 'Check Vehículos', icon: 'local_shipping' },
  CHECK_MAQUINARIA: { label: 'Check Maquinaria', icon: 'precision_manufacturing' },
}

/** Orden de presentación de los tipos. No es alfabético: sigue el flujo de terreno. */
export const TIPOS_DOCUMENTO_ORDEN: TipoDocumento[] = [
  'EPP',
  'CAPACITACION',
  'ATS',
  'CHECK_CAMIONETA',
  'CHECK_MAQUINARIA',
]

/**
 * Rótulo de un tipo que llega como string crudo desde la API. Un tipo
 * desconocido (uno nuevo que el backend ya emite y este build todavía no
 * conoce) devuelve el valor crudo en vez de romper la fila.
 */
export function labelTipoDocumento(tipo: string | null): string | null {
  if (!tipo) return null
  return TIPO_DOCUMENTO_CONFIG[tipo as TipoDocumento]?.label ?? tipo
}
